// extracted by mini-css-extract-plugin
module.exports = {"description":"_6c97079b1b--description--GLGFk"};